import React, { ReactNode } from 'react';

import { Text } from '@fly/core';

export interface EnvironmentEmptyStateProps {
  darkModeImage: string;
  lightModeImage: string;
  title: ReactNode;
  subtitle?: ReactNode;
  children?: ReactNode;
  className?: string;
  imageAlt?: string;
}

export function EnvironmentEmptyState({
  darkModeImage,
  lightModeImage,
  title,
  subtitle,
  children,
  className = '',
  imageAlt = 'empty state',
}: EnvironmentEmptyStateProps) {
  return (
    <div
      data-testid='runtime-environment-empty-state'
      className={`align-center mt-fly-4 flex w-full flex-col justify-center gap-fly-6 ${className}`}
    >
      <div className='relative flex items-center justify-center'>
        <img
          data-testid='runtime-environment-empty-state-img-dark'
          height={240}
          width={495}
          src={darkModeImage}
          alt={imageAlt}
          className='hidden dark:block'
        />
        {/* Show in light mode only */}
        <img
          data-testid='runtime-environment-empty-state-img-light'
          height={240}
          width={495}
          src={lightModeImage}
          alt={imageAlt}
          className='block dark:hidden'
        />
      </div>
      <div className='flex flex-col items-center justify-center gap-fly-6'>
        <div className='flex flex-col gap-fly-2 text-center'>
          <Text>{title}</Text>
          {subtitle && (
            <Text className='whitespace-pre-line' color='neutral' size='2'>
              {subtitle}
            </Text>
          )}
        </div>
        {children}
      </div>
    </div>
  );
}
